import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { paginationComponentOptions, paginationRowsPerPageOptions } from "../../../config/constants";
import { TemplatesHistoryData } from "../../../types";
import { ButtonBackCustom } from "../../../styled-components/Buttons";
import LoadingComponent from "../../../components/Loading";
import { Button, Icon } from "@jarvis-catalyst/ui-components";
import { parseDate } from "../../../utils/parseDate";
import TemplatesHistoryModal from "../../../components/Modal/templatesHistoryModal";

interface Props {
  results: TemplatesHistoryData[];
  onBack: () => void;
  isLoading: boolean;
}

const ConsentResultsTable: React.FC<Props> = ({ results, onBack, isLoading }) => {
  const [draftId, setDraftId] = useState<string | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);

  if (openModal) {
    return (
      <TemplatesHistoryModal
        isReadOnly={false}
        isOpen={openModal}
        setIsOpen={setOpenModal}
        title={""}
        draftId={draftId as string}
      />
    );
  }

  return (
    <>
      <div
        style={{
          maxWidth: "150px"
        }}
      >
        <div className="mt-2 mb-2">
          <ButtonBackCustom onClick={onBack}>Volver</ButtonBackCustom>
        </div>
      </div>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <DataTable
            title=""
            columns={[
              {
                name: "Name",
                selector: (row: TemplatesHistoryData) => row.name,
                width: "200px",
                sortable: false
              },
              {
                name: "Country",
                selector: (row: TemplatesHistoryData) => row.country,
                width: "75px",
                sortable: true
              },
              {
                name: "Business",
                selector: (row: TemplatesHistoryData) => row.business,
                width: "90px",
                sortable: true
              },
              {
                name: "Version",
                selector: (row: TemplatesHistoryData) => row.version,
                width: "75px",
                sortable: true
              },
              {
                name: "Purpose Name",
                selector: (row: TemplatesHistoryData) => row.purpose.purposeName,
                width: "150px",
                sortable: false
              },
              {
                name: "Approved",
                selector: (row: TemplatesHistoryData) =>
                  row.approved_audit?.approved_at ? "Aprobado" : "Por Aprobar",
                width: "100px",
                sortable: true
              },
              {
                name: "Approved By",
                selector: (row: TemplatesHistoryData) => row.approved_audit?.approved_by ?? "",
                width: "200px",
                sortable: false
              },
              {
                name: "Created At",
                selector: (row: TemplatesHistoryData) =>
                  parseDate(String(row.created_audit?.created_at), "dd/MM/yyyy") ?? "",
                width: "100px",
                sortable: true
              },
              {
                name: "Created By",
                selector: (row: TemplatesHistoryData) => row.created_audit?.created_by ?? "",
                width: "200px",
                sortable: false
              },
              {
                name: "Actions",
                cell: (row: TemplatesHistoryData) => (
                  <Button
                    onClick={() => {
                      setDraftId(row.id);
                      setOpenModal(true);
                    }}
                  >
                    <Icon name="View" color="white" size={24} />
                  </Button>
                ),
                width: "100px",
                ignoreRowClick: true,
                allowOverflow: true,
                button: true
              }
            ]}
            data={results}
            pagination
            paginationPerPage={20}
            fixedHeaderScrollHeight="600px"
            paginationRowsPerPageOptions={paginationRowsPerPageOptions}
            fixedHeader
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent="No data available"
            customStyles={{
              rows: {
                style: {
                  minHeight: "45px"
                }
              },
              headCells: {
                style: {
                  paddingLeft: "8px",
                  paddingRight: "8px"
                }
              },
              cells: {
                style: {
                  paddingLeft: "8px",
                  paddingRight: "8px"
                }
              }
            }}
          />
        </>
      )}
    </>
  );
};

export default ConsentResultsTable;
